// 引入axios（axios进行二次封装）
import request from '@/utils/request'

// 邮箱登录
export function emailLogin(data) {
  return request({
    url: '/system/api/smallprogram/login/emailLogin',
    method: 'post',
    data
  })
}

// 手机号码登录接口
export function phoneLogin(data) {
  return request({
    url: '/system/api/smallprogram/login/login',
    method: 'post',
    data
  })
}

// 邮箱注册
export function emailRegisterUser(data) {
  return request({
    url: '/system/api/smallprogram/login/emailRegisterUser',
    method: 'post',
    data
  })
}

// 手机号注册
export function phoneRegisterUser(data) {
  return request({
    url: '/system/api/smallprogram/login/phoneRegisterUser',
    method: 'post',
    data
  })
}

// 邮箱忘记密码
export function forgetEditPwd(data) {
  return request({
    url: '/system/api/smallprogram/login/forgetEditPwd',
    method: 'post',
    data
  })
}

// 手机号忘记密码
export function phoneForgetEditPwd(data) {
  return request({
    url: '/system/api/smallprogram/login/phoneForgetEditPwd',
    method: 'post',
    data
  })
}

// 发送邮箱验证码
export function forgetSendEmailCode(data) {
  return request({
    url: '/system/api/smallprogram/login/forgetSendEmailCode',
    method: 'get',
    params: data
  })
}

// 注册发送邮箱验证码
export function registerSendEmailCode(data) {
  return request({
    url: '/system/api/smallprogram/login/registerSendEmailCode',
    method: 'get',
    params: data
  })
}

// 发送手机号验证码
export function sendPhoneRegisterVerCode(data) {
  return request({
    url: '/system/api/smallprogram/login/sendPhoneRegisterVerCode',
    method: 'post',
    data
  })
}

// 忘记密码，手机号发送验证码
export function forgetSendPhoneCode(data) {
  return request({
    url: '/system/api/smallprogram/login/forgetSendPhoneCode',
    method: 'post',
    data
  })
}

// 修改手机号，发送验证码
export function editPhoneSendCode(data) {
  return request({
    url: '/system/api/smallprogram/login/editPhoneSendCode',
    method: 'post',
    data
  })
}

// 上传文件
export function wxUploadFile(data) {
  return request({
    url: '/system/api/admin/upload/wxUploadFile',
    method: 'post',
    data
  })
}

// 批量上传文件
export function wxUploadFiles(data) {
  return request({
    url: '/system/api/admin/upload/wxUploadFiles',
    method: 'post',
    data
  })
}

//  新增销售记录
export function addSaleRecord(data) {
  return request({
    url: '/ebike/listek-ebike/api/smallprogram/addSaleRecord',
    method: 'post',
    data
  })
}

// 销售记录分页
export function querySaleRecordPage(data) {
  return request({
    url: '/ebike/listek-ebike/api/smallprogram/querySaleRecordPage',
    method: 'post',
    data
  })
}

// 查询维修类型
export function queryEbikeMaintainTypeList(data) {
  return request({
    url: '/ebike/listek-ebike/api/smallprogram/queryEbikeMaintainTypeList',
    method: 'get',
    params: data
  })
}

// 新增维修记录
export function addEbikeMaintainRecord(data) {
  return request({
    url: '/ebike/listek-ebike/api/smallprogram/addEbikeMaintainRecord',
    method: 'post',
    data
  })
}

// 维修记录分页
export function queryMaintainRecordPage(data) {
  return request({
    url: '/ebike/listek-ebike/api/smallprogram/queryMaintainRecordPage',
    method: 'post',
    data
  })
}

// 修改邮箱-发送验证码
export function editEmailSendEmailCode(data) {
  return request({
    url: '/system/api/smallprogram/login/editEmailSendEmailCode',
    method: 'get',
    params: data
  })
}

// 修改邮箱
export function editEmail(data) {
  return request({
    url: '/system/api/smallprogram/login/editEmail',
    method: 'post',
    data
  })
}

// 修改手机号
export function editPhone(data) {
  return request({
    url: '/system/api/smallprogram/login/editPhone',
    method: 'post',
    data
  })
}

// 修改时区
export function updateTimeZone(data) {
  return request({
    url: '/system/api/smallprogram/login/updateTimeZone',
    method: 'post',
    data
  })
}
